import React from 'react';
import { SelectSingle } from './index';

/**
 * GroupStudentContractSelector - Shows each student in a group with their own contract dropdown
 * 
 * @param {Array} groupStudents - Array of student objects with {value: studentId, label: studentName, ...}
 * @param {Object} contractsByStudent - Object mapping studentId to array of contracts
 * @param {Object} studentContracts - Current selected contracts {studentId: contractOption}
 * @param {Function} onContractChange - Callback when a contract is changed (studentId, contractOption)
 */
function GroupStudentContractSelector({ groupStudents, contractsByStudent, studentContracts, onContractChange }) {
    if (!groupStudents || groupStudents.length === 0) {
        return <div className="text-gray-500">No students in this group</div>;
    }

    return (
        <div className="flex flex-col gap-y-3">
            <div className="text-sm text-gray-600 font-medium">
                Select Contract for Each Student:
            </div>
            {groupStudents.map((student, index) => {
                const studentId = student.value;
                const studentName = student.label;
                const availableContracts = contractsByStudent[studentId] || [];
                
                // Debug log to see structure
                if (index === 0 && availableContracts.length > 0) {
                    console.log('[GROUP_CONTRACTS] First student ID:', studentId);
                    console.log('[GROUP_CONTRACTS] Available contracts count:', availableContracts.length);
                    console.log('[GROUP_CONTRACTS] First contract:', availableContracts[0]);
                    console.log('[GROUP_CONTRACTS] Contract keys:', Object.keys(availableContracts[0] || {}));
                }
                
                // Build contract options for this student
                // availableContracts is already an array of options with {value, label, obj}
                const contractOptions = [
                    { value: -1, label: 'No Contract', object: null },
                    ...availableContracts  // Already formatted as options!
                ];

                // Get currently selected contract for this student
                const selectedContract = studentContracts[studentId] || contractOptions[0];

                return (
                    <div key={studentId} className="flex flex-row gap-x-3 items-center border-b border-gray-200 pb-2">
                        <div className="w-1/3 font-medium text-gray-700">
                            {index + 1}. {studentName}
                        </div>
                        <div className="w-2/3">
                            <SelectSingle
                                id={`student-contract-${studentId}`}
                                name={`studentContract-${studentId}`}
                                value={selectedContract}
                                onChange={(e) => {
                                    // e.target.value is the full option object (SelectSingle returns the option, not just value)
                                    console.log('[GROUP_CONTRACTS] Contract changed for', studentName, ':', e.target.value);
                                    onContractChange(studentId, e.target.value);
                                }}
                                options={contractOptions}
                            />
                        </div>
                    </div>
                );
            })}
            <div className="text-xs text-gray-500 mt-2">
                💡 Tip: Each student can have different contract dates as long as the contract type matches the group's purpose.
            </div>
        </div>
    );
}

export default GroupStudentContractSelector;

